<template>
  <span>{{ name }}</span>
</template>

<script>
export default {
  name: 'SuspiciousActivityName',
  props: {
    type: String
  },
  computed: {
    name () {
      switch (this.type) {
        case 'mesmo-cartao-data-valor': return 'Mesmo cartão na mesma data com o mesmo valor'
        case 'mesmo-valor-e-data': return 'Mesmo valor na mesma data'
        case '500-uma-parcela': return 'Vendas de R$ 500,00 ou mais em uma parcela'
      }

      return null
    }
  }
}
</script>
